/**
 * Testimonials Section — Pure presentation, no state.
 */
import React from 'react';

const TestimonialsSection = ({ testimonials }) => (
  <section className="section" data-testid="testimonials-section">
    <div className="section-header">
      <h2 className="section-title">Historias de Éxito</h2>
      <p className="section-subtitle">
        Gente real que dejó de procrastinar y empezó a ahorrar (sí, es posible) ⭐
      </p>
    </div>
    <div className="testimonials-grid">
      {testimonials.map((testimonial) => (
        <div key={testimonial.id} className="testimonial-card">
          <p className="testimonial-message">"{testimonial.message}"</p>
          <div className="testimonial-footer">
            <div className="testimonial-author">
              <img src={testimonial.avatar} alt={testimonial.name} className="testimonial-avatar" />
              <div>
                <p className="testimonial-name">{testimonial.name}</p>
                <p className="testimonial-role">{testimonial.role}</p>
              </div>
            </div>
            <div className="testimonial-savings">
              <span className="savings-label">Ha ahorrado</span>
              <span className="savings-amount">{testimonial.savings}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default TestimonialsSection;
